module.exports = __webpack_public_path__ + "img/malware.b4a1a3ea.png";